var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.canAddLabs)?_c('FormAddLab400',{attrs:{"examenes400":_vm.examenes400}}):_vm._e(),_c('CardEnvioLabs400',{attrs:{"examenes400":_vm.examenes400}}),_c('EditarEnvioLab400',{attrs:{"examenes400":_vm.examenes400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }